import { render } from "./AlimDisplay.vue?vue&type=template&id=14fdf340"
import script from "./AlimDisplay.vue?vue&type=script&lang=js"
export * from "./AlimDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__